import { IProduct, ISearchAttribute } from '@cbgms/api'
import { useCallback } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

export interface IRouteState {
  pathBeforeModal: string
  product: IProduct
  search?: string
  hash?: string
  pathname: string
  placeholderLineUUID?: string
  searchAttributes?: ISearchAttribute[]
}

export const searchRegExpProductDetails = /\/product-details-modal.*/
export const searchRegExpProductDetailsReplacer = /\/(product-details-modal|product-lead-time-modal)(?:\/.*)?$/
const trailingSlashRegExp = /\/$/g
export const trimTrailingSlash = (path: string) => path.replace(trailingSlashRegExp, '')

export const basePath = '/product-details-modal/'
export const fullPath = `(/?.*)${basePath}:idType/:productID?/:lineUUID?`
export const buildProductDetailsDialogPath = (path: string) => `${trimTrailingSlash(path)}${fullPath}`
export const buildReplacementProductDetailsDialogPath = (
  pathname: string,
  newIdType: string,
  newProductID: string,
  placeholderLineUUID?: string
) => {
  const id = newProductID || '__'
  const idType = newIdType || '__'
  const basePart = `${pathname.replace(searchRegExpProductDetailsReplacer, '')}${basePath}${idType}/${id}`
  return placeholderLineUUID ? `${basePart}/${placeholderLineUUID}` : basePart
}

export const useCloseViaNavigation = () => {
  const { pathname, state } = useLocation<IRouteState>()
  const history = useHistory()
  // Serialize searchAttributes for stable dependency comparison to avoid
  // unnecessary callback recreation when the array reference changes
  const searchAttributesKey = JSON.stringify(state?.searchAttributes)
  return useCallback(() => {
    // use history to move back, when not available simply remove the `info-modal`.
    if (state?.pathBeforeModal) {
      // Preserve searchAttributes in the location state so that the ProductSearchAttributeContext
      // retains the current search state when the component remounts after closing the modal
      const searchAttributes = searchAttributesKey ? JSON.parse(searchAttributesKey) : undefined
      history.replace(`${state.pathBeforeModal}${state.hash || ''}`, {
        searchAttributes
      })
    } else {
      history.replace(pathname.replace(searchRegExpProductDetails, ''))
    }
  }, [state?.pathBeforeModal, state?.hash, searchAttributesKey, pathname])
}
